import React, { useState, useEffect, useContext } from 'react';
import ReportService from "../../controller/ReportController/ReportController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Cookies from "js-cookie";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";

function ReportListPage() {
    const navigate = useNavigate();

    const [ReportList, setReportList] = useState([]);
    const [ModuleID, setModuleID] = useState("0");
    const [formList, setFormList] = useState([]);

    const { theme } = useContext(ThemeContext);

    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    // Handle dropdown change
    const handleFieldChange = (e) => {
        setModuleID(e.target.value);
    };

    const redirectCallback = () => {
        navigate('/');
    };

    const fetchCompanyReport = async (ModuleID) => {
        try {
            const reportData = await ReportService.GetCompanyReports(redirectCallback, ModuleID);
            setReportList(reportData || []);
        } catch (error) {
            console.error('Error fetching Reports:', error);
        }
    };

    const fetchForms = async (ClientID) => {
        try {
            const list = await ModuleService.GetAllModules();
            setFormList(list || []);
        } catch (error) {
            console.error('Error fetching Modules:', error);
        }
    };

    useEffect(() => {
        fetchCompanyReport(ModuleID);
    }, [ModuleID]);

    useEffect(() => {
        fetchForms(CompanyID);
    }, [CompanyID]);

    const handleDefaultChange = async (reportID, value) => {
        try {
            debugger;
            await ReportService.SetDefaultReport(reportID, value, redirectCallback);

            // Refresh list after update
            fetchCompanyReport(ModuleID);
        } catch (error) {
            console.error("Error updating default:", error);
        }
    };

    return (
        <div>
            <div className="row mb-3" style={{ marginTop: "10px" }}>
                <div className="col-sm-12">
                    <label htmlFor="inputText" className="col-sm-2 col-form-label"></label>
                    <div className="col-sm-4">
                        <select
                            name="ModuleID"
                            className="form-control"
                            onChange={handleFieldChange}
                            value={ModuleID}
                        >
                            <option value="0">Select Module</option>
                            {formList.map((form) => (
                                <option
                                    key={form.PK_SearchModule_ID}
                                    value={form.PK_SearchModule_ID}
                                >
                                    {form.vc_ModuleName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>
                        <th>Report Name</th>
                        <th>Description</th>
                        <th>Module</th>
                        <th>Default</th>
                        <th style={{ textAlign: "right" }}>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {ReportList.map((report) => (
                        <tr key={report.ID}>
                            <td>{report.ReportTitle}</td>
                            <td>{report.Description}</td>
                            <td>{report.vc_ModuleName}</td>
                            <td>{report.Default}</td>
                            <td style={{ textAlign: "right" }}>

                                <select
                                    className="form-control"
                                    value={report.IsDefault}
                                    onChange={(e) =>
                                        handleDefaultChange(report.ID, e.target.value)
                                    }
                                >
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                </select>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ReportListPage;